import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { PolicyDetailsState, PolicySection } from './types';

const initialState: PolicyDetailsState = {
  sections: [],
  status: {
    loading: false,
    error: '',
  },
};

export const policyDetailsSlice = createSlice({
  name: 'policyDetails',
  initialState,
  reducers: {
    setPolicySections(state, action: PayloadAction<PolicySection[]>) {
      state.sections = action.payload;
    },
    setPolicyDetailsLoading(state, action: PayloadAction<boolean>) {
      state.status.loading = action.payload;
    },
    setPolicyDetailsError(state, action: PayloadAction<string>) {
      state.status.error = action.payload;
    },
    resetPolicyDetailsState(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setPolicySections,
  setPolicyDetailsLoading,
  setPolicyDetailsError,
  resetPolicyDetailsState,
} = policyDetailsSlice.actions;

const reducer = {
  policyDetails: policyDetailsSlice.reducer,
};

export default reducer;
